/* istanbul ignore file */
/**
 * Enumeration of Signup Types
 */
export const SignupType = Object.freeze({
    BRAND_AFFILIATE: 'BRAND_AFFILIATE',
    CUSTOMER: 'CUSTOMER',
    MEMBER: 'MEMBER'
});
